(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mto-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initShopTheLook(root) {
      if (root.dataset.stlInit === 'true') return;
      const cards = [...root.querySelectorAll('[data-stl-card]')];
      const hotspots = [...root.querySelectorAll('[data-stl-hotspot]')];
      const dots = [...root.querySelectorAll('[data-stl-dot]')];
      if (cards.length === 0) return;
      root.dataset.stlInit = 'true';

      let current = 0;

      const setActive = (index) => {
        current = (index + cards.length) % cards.length;
        cards.forEach((card, i) => {
          card.hidden = i !== current;
        });
        hotspots.forEach((hotspot, i) => {
          hotspot.classList.toggle('mto-stl__hotspot--active', i === current);
          hotspot.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('mto-stl__dot--active', i === current);
          dot.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
      };

      hotspots.forEach((hotspot) => {
        hotspot.addEventListener('click', () => setActive(Number(hotspot.dataset.index)));
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => setActive(Number(dot.dataset.index)));
      });

      root.querySelector('.mto-stl__arrow--prev')?.addEventListener('click', () => setActive(current - 1));
      root.querySelector('.mto-stl__arrow--next')?.addEventListener('click', () => setActive(current + 1));

      setActive(0);
    }

    const initAll = () => document.querySelectorAll('.mto-stl').forEach(initShopTheLook);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.mto-stl');
      if (section) initShopTheLook(section);
    });

    // Selecting a hotspot block in the theme editor activates it
    document.addEventListener('shopify:block:select', (event) => {
      const hotspot = event.target.closest?.('[data-stl-hotspot]') || event.target.querySelector?.('[data-stl-hotspot]');
      if (!hotspot) return;
      const root = hotspot.closest('.mto-stl');
      if (root) hotspot.click();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
